import { jsxs, jsx } from "react/jsx-runtime";
import "react";
const RichContentImages = (props) => {
  return props.images.imageUris.map((uri, index) => /* @__PURE__ */ jsxs("div", { className: "image-entry", children: [
    /* @__PURE__ */ jsx("img", { alt: "Rich Content Descriptor", src: uri }),
    /* @__PURE__ */ jsx("label", { children: props.images.captions[index] })
  ] }, index));
};
export {
  RichContentImages as default
};
//# sourceMappingURL=RichContentImages.js.map
